import Fetch from "../../../fetch";
const token = () => "Bearer " + localStorage.getItem("token");

export const getRoles = async params => {
  const route = generateUrl(params, "roles");
  return await Fetch({ route, method: "GET", token: token() });
};

export const getPermission = async params => {
  const route = generateUrl(params, "accesses");
  return await Fetch({ route, method: "GET", token: token() });
};

export const updatePermission = async ({ id, values }) => {
  return await Fetch({
    route: "accesses/" + id,
    method: "PUT",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const createRole = async values => {
  return await Fetch({
    route: "roles",
    method: "POST",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const updateRole = async ({ id, values }) => {
  return await Fetch({
    route: "roles/" + id,
    method: "PUT",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const deleteRole = async id => {
  return await Fetch({
    route: "roles/" + id,
    method: "DELETE",
    token: token()
  });
};

function generateUrl(params, baseUrl) {
  const ret = [];
  for (let key in params) {
    if (params[key] !== "") {
      ret.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
  }
  const paramString = ret.join("&");
  return paramString ? baseUrl + "?" + paramString : baseUrl;
}
